import React from 'react';

import Config from './core/Config';

const config: Config = (window as any).__hugotconfig__;

if (process.env.NODE_ENV !== 'production' && config.DISABLE_WDYR == null) {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
  });
}
